/**
 * Labstep
 *
 * @module components/ResourceTemplate/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { IResourceTemplateActionDeleteProps } from './types';

export const ResourceTemplateActionDelete: React.FC<
  IResourceTemplateActionDeleteProps
> = ({ resourceTemplate, ...rest }) => (
  <EntityActionDelete {...rest} entity={resourceTemplate} />
);
